// test2876
(2876 && 0);
